import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getSnapshotQaSpecHeader } from 'services/product';
import { useParams } from 'react-router-dom';
import { useGetProductFullView } from 'hooks';
import { checkIsDollarProduct } from 'pages/qa-spec/views/qa-spec-detail/utils';
import { useGetQaSpecDataHeader } from 'pages/qa-spec/query';

const getQueryKeyQaSpecDataHeader = (productId) => {
  return ['pim', 'snapshot', parseInt(productId), 'spec-data-header'];
};

export const useGetSnapshotQaDataHeader = ({
  enabled,
  productId,
  ...restProps
}) => {
  const queryClient = useQueryClient();

  const getSnapshotQaSpecDataHeader = async () => {
    const response = await getSnapshotQaSpecHeader({ productId });
    const { isSuccess, data } = response;
    if (!isSuccess) return null;

    return data;
  };

  const query = useQuery({
    queryKey: getQueryKeyQaSpecDataHeader(productId),
    queryFn: getSnapshotQaSpecDataHeader,
    enabled,
    ...restProps,
  });

  const invalidateSnapshotQaSpecDataHeader = () => {
    queryClient.invalidateQueries({
      queryKey: getQueryKeyQaSpecDataHeader(productId),
    });
  };

  return { ...query, invalidateSnapshotQaSpecDataHeader };
};

const dollarAdditionalFieldsProduct = ['type'];

export const useCheckRequiredForDollarProduct = () => {
  const { id: productId } = useParams();
  const { productFull } = useGetProductFullView({
    productId,
  });

  const { qaSpecDataHeader } = useGetQaSpecDataHeader({
    id: productId,
    isEnabled: !!productId,
  });

  const isTypeFood = qaSpecDataHeader?.type?.toLowerCase() === 'food';

  const checkRequiredFieldForDollarProduct = (fieldName) => {
    return (
      isTypeFood &&
      checkIsDollarProduct(productFull?.isOwner) &&
      dollarAdditionalFieldsProduct.includes(fieldName)
    );
  };

  return { checkRequiredFieldForDollarProduct };
};

export const useCheckQaSpecTypeFood = () => {
  const { id: productId } = useParams();

  const { qaSpecDataHeader } = useGetQaSpecDataHeader({
    id: productId,
    isEnabled: !!productId,
  });

  return qaSpecDataHeader?.type?.toLowerCase() === 'food';
};
